import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Input, Space, Tooltip } from "antd";
import mergeClassNames from "common/mergeClassNames";
import { useEffect, useState } from "react";

function CopyInput({ value, onChange = () => null, readOnly, copyToolTip, className = "" }) {
    const [inputValue, setInputValue] = useState(value);
    useEffect(() => {
        setInputValue(value);
    }, [value]);

    const onInputValueChange = (e) => {
        setInputValue(e.target.value);
        onChange(e.target.value);
    };

    return (
        <Space.Compact className={mergeClassNames("w-full", className)}>
            <Input onChange={onInputValueChange} readOnly={readOnly} disabled={!inputValue} value={inputValue} className="flex-1" />
            <Tooltip title={copyToolTip || "Copy Secret"}>
                <Button className="text-primary" icon={<FontAwesomeIcon icon={faCopy} />} disabled={!inputValue} onClick={() => navigator.clipboard.writeText(inputValue)} />
            </Tooltip>
        </Space.Compact>
    );
}

export default CopyInput;
